import type { Client } from '@zg-rentals/http-client';
import { CometUserAuthenticationWebHandler_getUser_queryOptions } from '@zg-rentals/ts-renter-info-client-react-query';
import { defineConfig } from '@zg-rentals/auth-react';
import { hasStrongAuth } from '@zg-rentals/auth-comet/strong';
import { renterInfoClient } from './rentalClient';

export const authConfig = defineConfig({
  queryOptions: ({ httpClient = renterInfoClient }: { httpClient?: Client }) =>
    CometUserAuthenticationWebHandler_getUser_queryOptions({ pageWithSensitiveInformation: true }, { httpClient }),
  isAuthorized: hasStrongAuth(),
});
